import { NextData } from './SidekickThreads';

export class SidekickRevision {
  id: string;
  flowID: number;
  stepData: [];
  createdAt: Date;
  reason: string;
  customerID: number;
  createdBy: number;
  nextData: NextData[];
}
